var mobileNavInit;

(function($){
		
	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	}
	
	mobileNavInit = function(){
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	}
	
	class MobileNav {
		constructor(element){
			this.$container = $(element);
			
			this.init();
			this.bind();
			// console.log(this);
			
		}
		init(){	
			this.$trigger = $(selectors.trigger, this.$container);
			this.$links = $('a', this.$container).not( this.$trigger );
		}
		
		bind(){
			this.$trigger.click( (e) => { this.toggle(); });
			this.$links.click( (e) => { this.hide(); });
		}
		
		toggle(){
			if( this.$container.hasClass('is-active') ){
				this.hide();
			}
			else {
				this.show();
			}
		}
		
		show(){
			this.$container.addClass('is-active');
		}
		
		hide(){
			this.$container.removeClass('is-active');
		}
		
	}

})(jQuery);
	
	
export default mobileNavInit;